// extracted by mini-css-extract-plugin
export default {"header":"bmr-page_header__hP4v0"};